module.exports = __webpack_public_path__ + "img/DE00122.23835dc7.png";